import { Sports } from '@/types';
import React from 'react';
import styles from '../style.module.css';
import RadioButton from './RadioButton';

type Props = {
  handleRadioChangeSport: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sport: Sports;
  showAll?: boolean;
};

const sports: Sports[] = ['cycling', 'running', 'swimming', 'all'];

const SportSelector = ({
  sport,
  handleRadioChangeSport,
  showAll = true,
}: Props) => {
  return (
    <div className={styles.radioButtons}>
      {sports.map((value) => (
        <RadioButton
          name="sports"
          value={value}
          checked={sport === value}
          onChange={handleRadioChangeSport}
          label={value}
          labelClassName={styles[`color-${value}`]}
          key={`input-${value}`}
          disabled={value === 'all' && !showAll}
        />
      ))}
    </div>
  );
};

export default SportSelector;
